import { render, staticRenderFns } from "./upcoming-schedules.vue?vue&type=template&id=0227a58f&"
import script from "./upcoming-schedules.vue?vue&type=script&lang=js&"
export * from "./upcoming-schedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports